'use client';

import RichText from 'molecules/RichText';
import styles from 'molecules/footerNote/footerNotes.module.scss';

import type { FooterNoteProps } from 'molecules/footerNote/config';
import type { FC } from 'react';

const FooterNotes: FC<FooterNoteProps> = ({ content }) => (
  <div className={styles.container}>
    {content && (
      <div className={styles.footerWrapper}>
        <RichText className={styles.footernote} content={content} />
      </div>
    )}
  </div>
);

export default FooterNotes;
